import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import ProcessStatusDiv from './ProcessStatusDiv'
import ProcessFormItemDiv from './ProcessFormItemDiv'
import ProcessDetail from './ProcessDetail'
import FlowRecordDetail from './FlowRecordDetail'

class ProcessManagementDetail extends React.Component {
    state = {
        changedValues基本信息: {},
        id: this.props.id,
    }

    componentDidMount = () => {
        this.doGetProcess(this.props.id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetProcess = (id) => {
        Tyan.doPostEvent({
            event: 'GetProcess',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { dispatch, onSave, onClose } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcess',
            data: { id, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.doGetProcess(id)
                }
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose, dispatch } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteProcess',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && values.流程名称
    }

    handleAddProcessStatus = () => {
        const { dispatch, onSave, onClose } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcess',
            data: { id, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id })
                    Tyan.pubForm.showDialog('流程状态设置', props => <ProcessStatusDiv {...props} id={0} processId={id} onRefresh={() => this.doGetProcess(id)} />)
                }
            }
        })
    }

    handleAddProcessFormItem = () => {
        const { dispatch, onSave, onClose } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcess',
            data: { id, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id })
                    Tyan.pubForm.showDialog('表单项设置', props => <ProcessFormItemDiv {...props} id={0} ProcessID={id} onRefresh={() => this.doGetProcess(id)} />)
                }
            }
        })
    }

    handleDoTestProcessDetail = () => {
        Tyan.pubForm.showDialog('流程测试', props => <ProcessDetail {...props} id={this.state.id} />)
    }

    handleOpenCustomerForm = () => {
        Tyan.pubForm.showDialog('流程测试1', props => <FlowRecordDetail {...props} processId={this.state.id} />)
    }

    fieldset基本信息 = () => {
        return [
            { _text: '流程名称', require: true, minWidth: '45%' },
            { _text: '编号前缀', require: true, minWidth: '45%' },
            // { _radio: '是否需要会签', minWidth: '45%', },
            { _radio: '分类', require: true, optionName: '分类', minWidth: '45%', },
            { _radio: '性质', optionName: '性质', minWidth: '45%', },
            { _radio: '申请角色限制', minWidth: '45%', },
            { _text: '申请角色范围', minWidth: '45%' },
            { _radio: '申请部门限制', minWidth: '45%', },
            { _select: '申请部门范围', minWidth: '45%' },
            { _radio: '申请人限制', minWidth: '45%', },
            { _text: '申请人范围', minWidth: '45%' },
            { _text: '相关人员', minWidth: '45%' },
            { _radio: '企业微信', optionName: '企业微信', minWidth: '45%', },
            { _int: '排序', minWidth: '45%' },
            { _text: '保存执行代码', minWidth: '95%', maxRows: 5 },
        ]
    }

    fieldset表单项 = () => {
        const { id } = this.state
        return [{
            _grid: '', name: '表单项', rowNumbers: true, /*minRows: 3, maxRows: 11, */ height: '100%',
            columns: [
                { _text: '表单项名称', flex: 3 },
                { _text: '显示名称', flex: 2 },
                { _text: '数据类型', flex: 2 },
                { _text: '是否必填', flex: 2 },
            ],
            buttons: [
                { _button: '添加...', /* icon: 'plus', */  handler: this.handleAddProcessFormItem, },
            ],
            onDoubleTap: data => {
                Tyan.pubForm.showDialog('流程表单项', props => <ProcessFormItemDiv {...props} id={data.id} ProcessID={id} onRefresh={() => this.doGetProcess(id)} />)
            },
        }]
    }

    fieldset流程状态 = () => {
        const { id } = this.state
        return [{
            _grid: '', name: '流程状态', rowNumbers: true, /*minRows: 3, maxRows: 11, */ height: '100%',
            columns: [
                { _text: '状态名称', flex: 2 },
                { _text: '执行人', flex: 3 },
            ],
            buttons: [
                { _button: '添加...', /* icon: 'plus', */  handler: this.handleAddProcessStatus, },
            ],
            onDoubleTap: data => {
                Tyan.pubForm.showDialog('流程状态设置', props => <ProcessStatusDiv {...props} id={data.id} processId={id} onRefresh={() => this.doGetProcess(id)} />)
            },
        }]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="1100"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    // { _button: '测试格式', icon: 'share', handler: this.handleDoTestProcessDetail, disabled: this.bSave(), },
                    // { _button: '测试格式1', icon: 'share', handler: this.handleOpenCustomerForm, disabled: this.bSave(), },
                ]}
            fieldsets={
                [
                    { title: '流程信息', name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'top', height: '44%', },
                    {
                        _fieldsets: [
                            { title: '表单项', name: '基本信息', _fieldset: this.fieldset表单项(), fullblock: true },
                            { title: '流程状态', name: '基本信息', _fieldset: this.fieldset流程状态(), fullblock: true },
                        ]
                    }
                ]
            }
        />
    }
}

export default connect()(ProcessManagementDetail)